export default "__VITE_ASSET__20Ug5T99__"